import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-copyright">© 2010 AdS — Amanti dello Scoutball</div>
        </div>
        <div className="footer-center">
          <div className="footer-copyright">AGESCI · Zona di Bologna</div>
        </div>
        <div className="footer-social">
          <a href="https://www.instagram.com/amanti.dello.scoutball/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
